"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Utility class for fetching paginated resources. In order to use the class you
 * are required to define (or use) an existing adapter.
 *
 * @Param {IPaginatedResourceAdapter} adapter = The adapter to use.
 * @Param {initialValue} initialValue         = The initial value to use.
 *
 * @Example
 *   const source = [1, 2, 3, 4];
 *   const resource = new PaginatedResource(
*      {
 *        next: current => [...current, source[current.length]],
 *        isExhausted: current => current.length >= source.length,
 *     }, []);
 *
 *   const paginated = resource.all();
 *   //=> [1, 2, 3, 4];
 */
class PaginatedResource {
    constructor(definition, initialValue) {
        this.definition = definition;
        this.initialValue = initialValue;
        this.mergeNext = (current) => __awaiter(this, void 0, void 0, function* () {
            const next = yield this.definition.next(current);
            if (yield this.definition.isExhausted(next)) {
                return next;
            }
            return this.mergeNext(next);
        });
    }
    all() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mergeNext(this.initialValue);
        });
    }
}
exports.PaginatedResource = PaginatedResource;
//# sourceMappingURL=paginated-resource.js.map